export default "__VITE_PUBLIC_ASSET__374a97fd__"